<template>
  <div>
    <CrudList
      title="Tipos de Spots"
      storeName="Type_spots"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      sortable
      next-link="/admin/size_spots"
      :breadcrumbs="[
        {
          text: 'Spots y vehículos',
          disabled: false,
          href: '/admin/type_spots'
        },
        {
          text: 'Tipos de Spots',
          disabled: false,
          href: '#'
        }
      ]"
    >
      <template v-slot:picture="{ item }">
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-list-item-avatar v-if="item.picture">
              <img :src="item.picture" alt="" />
            </v-list-item-avatar>
          </v-col>
        </v-row>
      </template>
    </CrudList>
  </div>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
  data: () => ({
    offsetTop: 0
  }),
  methods: {
    onScroll(e) {
      this.offsetTop = e.target.scrollTop;
    }
  }
};
</script>
